"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarCatalogEditComplictation = void 0;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var messageContext_1 = require("../../hoc/messageContext");
var selectors_1 = require("../../redux/selectors");
var icons_1 = require("@ant-design/icons");
var catalogCarSlice_1 = require("../../redux/slice/catalogCarSlice");
var carCatalogAddComplictation_1 = require("../carCatalogAddComplictation/carCatalogAddComplictation");
var carCatalogAddExtras_1 = require("../carCatalogAddExtras/carCatalogAddExtras");
var form_1 = __importDefault(require("antd/es/form"));
var input_1 = __importDefault(require("antd/es/input"));
var button_1 = __importDefault(require("antd/es/button"));
var popconfirm_1 = __importDefault(require("antd/es/popconfirm"));
var space_1 = __importDefault(require("antd/es/space"));
var table_1 = __importDefault(require("antd/es/table"));
var typography_1 = __importDefault(require("antd/es/typography"));
var menu_1 = __importDefault(require("antd/es/menu"));
var modal_1 = __importDefault(require("antd/es/modal"));
var flex_1 = __importDefault(require("antd/es/flex"));
var select_1 = __importDefault(require("antd/es/select"));
var Title = typography_1.default.Title;
var selectedGroup = null;
var CarCatalogEditComplictation = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var id = (0, react_router_dom_1.useParams)().id;
    var catalogCar = (0, react_redux_1.useSelector)(selectors_1.catalogCarSelector).catalogCar;
    var _a = (0, messageContext_1.useMessageContext)(), showSuccess = _a.showSuccess, showError = _a.showError;
    var _b = (0, react_1.useState)(null), configurations = _b[0], setConfigurations = _b[1];
    var _c = (0, react_1.useState)(selectedGroup), selectGroup = _c[0], setPackageGroup = _c[1];
    var form = form_1.default.useForm()[0];
    var _d = (0, react_1.useState)(false), isModalVisible = _d[0], setIsModalVisible = _d[1];
    var _e = (0, react_1.useState)(null), extras = _e[0], setExtras = _e[1];
    var _f = (0, react_1.useState)(false), loading = _f[0], setLoading = _f[1];
    var onSave = (0, react_1.useCallback)(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/car_catalog_configurations/").concat(values.id), {
                            method: 'PUT',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                car_catalog_configuration: {
                                    car_catalog_id: catalogCar === null || catalogCar === void 0 ? void 0 : catalogCar.id,
                                    package_group: values.package_group,
                                    package_name: values.package_name,
                                    volume: values.volume,
                                    transmission: values.transmission,
                                    power: values.power,
                                    price: values.price,
                                    credit_discount: values.credit_discount,
                                    trade_in_discount: values.trade_in_discount,
                                    recycling_discount: values.recycling_discount,
                                    special_price: values.special_price,
                                },
                            }),
                        })];
                case 1:
                    response = _a.sent();
                    if (response.ok) {
                        setLoading(false);
                        dispatch((0, catalogCarSlice_1.catalogCarLoader)(id));
                        showSuccess('Комплектация успешно обновлена');
                    }
                    else {
                        setLoading(false);
                        showError('Ошибка при обновлении комплектации');
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [catalogCar, id, dispatch, showSuccess, showError]);
    var onDelete = function (configId) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/car_catalog_configurations/").concat(configId), {
                        method: 'DELETE',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    })];
                case 1:
                    response = _a.sent();
                    if (response.ok) {
                        dispatch((0, catalogCarSlice_1.catalogCarLoader)(id));
                        showSuccess('Комплектация успешно удалена');
                    }
                    else {
                        showError('Ошибка при удалении комплектации');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var columns = (0, react_1.useMemo)(function () { return [
        {
            title: 'Название группы',
            dataIndex: 'package_group',
            key: 'package_group',
            render: function (_, record) { return (react_1.default.createElement(form_1.default.Item, { name: "package_group-".concat(record.key), initialValue: record.package_group, rules: [{ required: true, message: 'Введите название группы комплектаций' }] },
                react_1.default.createElement(input_1.default, { disabled: true }))); },
        },
        {
            title: 'Комплектация',
            dataIndex: 'package_name',
            key: 'package_name',
            render: function (_, record) { return (react_1.default.createElement(form_1.default.Item, { name: "package_name-".concat(record.key), initialValue: record.package_name, rules: [{ required: true, message: 'Введите название комплектации' }] },
                react_1.default.createElement(input_1.default, null))); },
        },
        {
            title: 'Объем',
            dataIndex: 'volume',
            key: 'volume',
            render: function (_, record) { return (react_1.default.createElement(form_1.default.Item, { name: "volume-".concat(record.key), initialValue: record.volume },
                react_1.default.createElement(input_1.default, { type: "number" }))); },
        },
        {
            title: 'КПП',
            dataIndex: 'transmission',
            key: 'transmission',
            render: function (_, record) { return (react_1.default.createElement(form_1.default.Item, { name: "transmission-".concat(record.key), initialValue: record.transmission },
                react_1.default.createElement(input_1.default, null))); },
        },
        {
            title: 'Мощность',
            dataIndex: 'power',
            key: 'power',
            render: function (_, record) { return (react_1.default.createElement(form_1.default.Item, { name: "power-".concat(record.key), initialValue: record.power },
                react_1.default.createElement(input_1.default, { type: "number" }))); },
        },
        {
            title: 'Цена, росс.руб',
            dataIndex: 'price',
            key: 'price',
            render: function (_, record) { return (react_1.default.createElement(form_1.default.Item, { name: "price-".concat(record.key), initialValue: record.price },
                react_1.default.createElement(input_1.default, { type: "number" }))); },
        },
        {
            title: 'Скидка за кредит, росс.руб',
            dataIndex: 'credit_discount',
            key: 'credit_discount',
            render: function (_, record) { return (react_1.default.createElement(form_1.default.Item, { name: "credit_discount-".concat(record.key), initialValue: record.credit_discount },
                react_1.default.createElement(input_1.default, null))); },
        },
        {
            title: 'Трейд-ин скидка, росс.руб',
            dataIndex: 'trade_in_discount',
            key: 'trade_in_discount',
            render: function (_, record) { return (react_1.default.createElement(form_1.default.Item, { name: "trade_in_discount-".concat(record.key), initialValue: record.trade_in_discount },
                react_1.default.createElement(input_1.default, { type: "number" }))); },
        },
        {
            title: 'Скидка за утилизацию, росс.руб',
            dataIndex: 'recycling_discount',
            key: 'recycling_discount',
            render: function (_, record) { return (react_1.default.createElement(form_1.default.Item, { name: "recycling_discount-".concat(record.key), initialValue: record.recycling_discount },
                react_1.default.createElement(input_1.default, { type: "number" }))); },
        },
        {
            title: 'Специальная цена, росс.руб',
            dataIndex: 'special_price',
            key: 'special_price',
            render: function (_, record) { return (react_1.default.createElement(form_1.default.Item, { name: "special_price-".concat(record.key), initialValue: record.special_price },
                react_1.default.createElement(input_1.default, { type: "number" }))); },
        },
        {
            title: 'Действия',
            key: 'action',
            width: '20%',
            render: function (_, record) { return (react_1.default.createElement(space_1.default, { size: "middle" },
                react_1.default.createElement(popconfirm_1.default, { title: "C\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435?", description: "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0432\u043D\u0435\u0441\u0435\u043D\u043D\u044B\u0435 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F?", onConfirm: function () {
                        var fields = [
                            "package_group-".concat(record.key),
                            "package_name-".concat(record.key),
                            "volume-".concat(record.key),
                            "transmission-".concat(record.key),
                            "power-".concat(record.key),
                            "price-".concat(record.key),
                            "credit_discount-".concat(record.key),
                            "trade_in_discount-".concat(record.key),
                            "recycling_discount-".concat(record.key),
                            "special_price-".concat(record.key),
                        ];
                        form.validateFields(fields)
                            .then(function (values) {
                            var updatedValues = fields.reduce(function (acc, field) {
                                var name = field.split('-')[0];
                                acc[name] = values[field];
                                return acc;
                            }, {});
                            onSave(__assign(__assign({}, record), updatedValues));
                        })
                            .catch(function () {
                            showError('Поля не заполнены.');
                        });
                    }, okText: "\u0414\u0430", cancelText: "\u041D\u0435\u0442" },
                    react_1.default.createElement(button_1.default, { icon: react_1.default.createElement(icons_1.SaveOutlined, null), loading: loading })),
                react_1.default.createElement(popconfirm_1.default, { title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u044E?", description: "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u044E?", onConfirm: function () {
                        onDelete(record.id);
                    }, okText: "\u0414\u0430", cancelText: "\u041D\u0435\u0442" },
                    react_1.default.createElement(button_1.default, { type: "link", danger: true, icon: react_1.default.createElement(icons_1.DeleteOutlined, null), loading: loading }, "\u0423\u0434\u0430\u043B\u0438\u0442\u044C")),
                react_1.default.createElement(button_1.default, { type: "link", onClick: function () {
                        setExtras(record.car_catalog_extras);
                        setIsModalVisible(true);
                    } }, "\u0421\u043E\u0441\u0442\u0430\u0432 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u0438"))); },
        },
    ]; }, []);
    var onFilterChange = function (value) {
        setPackageGroup(value);
        if (catalogCar) {
            var filterConfiguration = catalogCar.car_catalog_configurations.filter(function (elem) {
                return elem.package_group === value;
            });
            setConfigurations(filterConfiguration.flatMap(function (item) {
                return item.configurations.map(function (configuration) { return (__assign({ key: configuration.id, package_group: item.package_group }, configuration)); });
            }));
        }
    };
    (0, react_1.useEffect)(function () {
        selectedGroup = selectGroup;
        onFilterChange(selectedGroup);
    }, [selectGroup]);
    return (react_1.default.createElement("div", null, catalogCar ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Title, { level: 1 }, "\u041A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u0438 \u0438 \u0446\u0435\u043D\u044B"),
        react_1.default.createElement(select_1.default, { style: { width: 200 }, placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0433\u0440\u0443\u043F\u043F\u0443 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u0438", value: selectGroup, onChange: function (value) { return onFilterChange(value); }, options: catalogCar.car_catalog_configurations.map(function (configuration) { return ({
                label: configuration.package_group,
                value: configuration.package_group,
            }); }) }),
        react_1.default.createElement(form_1.default, { form: form, component: false },
            react_1.default.createElement(table_1.default, { columns: columns, dataSource: configurations || [], bordered: true, size: "middle", pagination: {
                    pageSize: 10,
                    showSizeChanger: false,
                    showTotal: function (total) { return "\u0412\u0441\u0435\u0433\u043E ".concat(total); },
                }, footer: function () {
                    return (react_1.default.createElement(flex_1.default, { gap: "middle", justify: "flex-start", align: "flex-start", vertical: true },
                        react_1.default.createElement(carCatalogAddComplictation_1.CarCatalogAddComplictation, null),
                        configurations ? (react_1.default.createElement(carCatalogAddExtras_1.CarCatalogAddExtras, { configurations: configurations })) : null));
                } })),
        react_1.default.createElement(modal_1.default, { title: 'Cостав комплектации', open: isModalVisible, onCancel: function () { return setIsModalVisible(false); }, footer: null }, extras ? (react_1.default.createElement(menu_1.default, { mode: "inline", items: extras.map(function (extra, extraIndex) {
                return {
                    key: "".concat(extra.group_name, "_").concat(extraIndex),
                    label: extra.group_name,
                    children: extra.extra_names.map(function (extraName) {
                        return { key: "".concat(extraName, "_").concat(extraIndex), label: extraName };
                    }),
                };
            }) })) : null))) : null));
};
exports.CarCatalogEditComplictation = CarCatalogEditComplictation;
